import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./About.css";
import img2 from "../../Assets/Quran-Reading-1-2.jpg";

const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: true, // Ensures animations run only once for better performance
    });
  }, []);

  return (
    <section className="about-section container mt-5">
      <div className="row align-items-center">
        {/* Left Column - Text Content */}
        <div className="col-lg-6 col-md-12">
          <h1 className="about-heading text-center" data-aos="fade-right">
            About Us
          </h1>
          <p className="about-description" data-aos="fade-right">
            Al-Nisa Quran Institute is a distinguished online academy offering
            Quranic education to learners worldwide. Our goal is to provide a
            comprehensive and precise understanding of Basic Quran Reading,
            Quran with Tajweed, Quran Memorization, Tafseer, and Quranic
            Arabic—all on a single platform with highly qualified and esteemed
            instructors.
            <br />
            <br />
            In today's digital age, learning the Quran has become more
            accessible than ever. With Al-Nisa, you can connect with expert
            Quran teachers from the comfort of your home. As one of the leading
            platforms for online Quranic learning, Al-Nisa offers flexible
            options for students to learn the Quran using any internet-enabled
            device, whether it’s a laptop, tablet, computer, or mobile phone.
            <br />
            <br />
            Since its establishment, Al-Nisa Quran Institute has steadily risen
            to prominence, driven by our unwavering dedication to student
            success and continual enhancement of our services. We are committed
            to expanding our reach and enabling as many students as possible to
            participate in the noble act of Hifz al-Quran, nurturing their
            spiritual growth and connection to the Quran.
          </p>
        </div>

        {/* Right Column - Image */}
        <div className="col-lg-6 col-md-12 mt-3">
          <img
            src={img2}
            alt="Quranic Education"
            className="img-fluid about-img"
            data-aos="zoom-in"
          />
        </div>
      </div>
    </section>
  );
};

export default About;
